import { styled } from 'styled-components';
import { breakpoint } from 'styles/globals';
import { getColor, type Theme } from 'styles/theme';
import Heading from 'styles/typography/Heading';
import { imageAndTitleLinkHover } from 'styles/imageAndTitleLinkHover';
import type { ThemeProps } from 'styles/theme/types';

export const Title = styled(Heading)<{ theme: Theme }>`
  display: flex;
  flex-direction: column;
  gap: 4px 32px;
  border-bottom: 1px solid ${getColor('borderBlack')};
  list-style-type: none;
  position: relative;
  padding-right: 24px;

  @media (${breakpoint.mdMin}) {
    gap: 4px 40px;
    flex-direction: row;
  }
`;

export const Wrapper = styled.div``;

export const RankingCardWrapper = styled.div<{ theme: ThemeProps }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 16px;
  ${imageAndTitleLinkHover};

  .card-image {
    flex: 0 0 30%;
    img {
      aspect-ratio: 1.51/1;
    }
  }
`;

export const Container = styled.div`
  display: grid;
  gap: var(--Grid-Gap);
  margin-top: var(--Grid-Margin); 
  grid-template-columns: repeat(1, 1fr);

  @media (${breakpoint.mmMin}) {
    grid-template-columns: repeat(3, 1fr);  
  }
`;
